/**
 * Take a parameter name and return the value of this parameter.
 * @param { String } parameterName - A parameter name.
 * @return { String }
 */
export const getParamValue = (parameterName) => {
    const urlParams = new URLSearchParams(window.location.search)

    return urlParams.get(parameterName) || ''
}

export const WindowProxy = typeof window !== 'undefined' && window.toString() === '[object Window]' && window

/**
 * Handles axios errors and console log them if in local development.
 * @param { Object } error - An axios error object.
 */
export const axiosErrorHandler = (error) => {
    if (process.env.NODE_ENV === 'development') {
        console.log('API Error:', error?.response?.config?.url, error?.response?.status)
    }
}
